import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import getDownloadToken, { getDownloadUrlBase, getUseDownloadUrlBase } from './getDownloadToken';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { format } from 'owa-strings';
import { getOwaCanaryCookie } from 'owa-service/lib/canary';
import { isStringNullOrWhiteSpace } from 'owa-strings';
import { OWA_ROOT_PREFIX } from '../constants';

export default function getDownloadUrlForClassicAttachment(
    mailboxId: string,
    id: AttachmentId,
    relativeUrlTemplate: string,
    includeDownloadToken: boolean,
    isPrint: boolean = false
): string {
    if (!id || !id.Id) {
        return null;
    }

    const attachmentUrl: string = format(relativeUrlTemplate, encodeURIComponent(id.Id));
    if (!getUseDownloadUrlBase() || isPrint) {
        return OWA_ROOT_PREFIX + attachmentUrl + '&X-OWA-CANARY=' + getOwaCanaryCookie();
    }

    let formatString: string = '{0}{1}/{2}&owa={3}&scriptVer={4}';
    if (isConsumer()) {
        formatString += '&isc=1';
    }

    // This default value will appear in gulp deployments, but in production
    //  the actual version will be used instead.
    let scriptVer = 'unofficial';

    if (
        window.bootstrapDiagnostics &&
        !isStringNullOrWhiteSpace(window.bootstrapDiagnostics.scriptVer)
    ) {
        scriptVer = window.bootstrapDiagnostics.scriptVer;
    }

    let result: string = format(
        formatString,
        getDownloadUrlBase(),
        mailboxId,
        attachmentUrl,
        window.location.hostname,
        scriptVer
    );

    if (includeDownloadToken) {
        result += '&X-OWA-CANARY=' + getOwaCanaryCookie();
        result += '&token=' + getDownloadToken();
    }

    return result;
}
